export const getStopwatchOffset = (milliseconds: number) => {
  const stopwatchOffset = new Date();
  stopwatchOffset.setMilliseconds(stopwatchOffset.getMilliseconds() + milliseconds);
  return stopwatchOffset;
};
